// Meta (Facebook) Pixel initialization helper.
// Pixel ID provided by Complemento Digital.
export const META_PIXEL_ID = '1288158062997995'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base code (once) and fires the initial PageView event.
 * Safe to call multiple times — the base script and init only run once.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')
}

/** Fire a PageView event (e.g. on SPA route changes). */
export function trackPageView(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}
